<template>
<ValidationObserver v-slot="{ invalid }">
  <div class="md-layout">
    <div class="md-layout-item md-size-50 no-padding-left">

      <group-card title="Upload New Documents" icon="file_upload" :loading="loading_document_requests">
        <div class="md-layout">
          <!-- Type -->
          <validated-autocomplete-input
            class="md-layout-item md-small-size-100 md-size-100"
            label="Document Type"
            v-model="selected_document_type"
            :options="documentTypes"
            force
          />
          <validated-text-input
            v-if="selected_document_type === 'Other'"
            class="md-layout-item md-small-size-100 md-size-100"
            label="Label for other type"
            v-model="selected_other_type" required>
          </validated-text-input>
          <!-- Applicants -->
          <validated-autocomplete-input
            class="md-layout-item md-small-size-100 md-size-100"
            label="Applicants"
            v-model="selected_applicant"
            :options="applicants"
            force
          />
        </div>
        <div class="md-layout">
          <!-- File -->
          <div class="md-layout-item md-small-size-100 md-size-95 dragdrop" @dragover="dragover" @dragleave="dragleave" @drop="drop">
            <i class="material-icons text_align-center">backup</i>
            <label for="assetsFieldHandle" class="block cursor-pointer">
              <div>
                <p>Drag and drop file here to upload document</p>
                <p>or</p>
              </div>
            </label>
            <ValidationProvider v-slot="{ failed, validate }"
                                rules="mimes:image/jpeg,image/jpeg,image/gif,image/png,text/plain,application/pdf,application/msword,application/vnd.oasis.opendocument.text,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
            >
              <input type="file"
                     multiple="false"
                     @change="onFileChange"
                     id="assetsFieldHandle"
                     ref="file"
                     accept=".pdf,.docx,.doc,.jpg,.jpeg,.gif,.png,.odt,.txt"
              />
              <span v-if="failed" class="error-msg">Only .pdf,.docx,.doc,.jpg,.jpeg,.png,.odt,.txt files accepted.</span>
            </ValidationProvider>
          </div>

        </div>
        <div class="md-layout">

          <!-- Add -->
          <div class="md-layout-item">
            <div>
              <loading-icon-text-button
                @click="onUploadFile"
                icon="file_upload"
                :loading="loading_document_requests"
                :class="{disabled:invalid}"
              >
                Upload
              </loading-icon-text-button>
            </div>
          </div>

        </div>
        <md-dialog-alert
          :md-active.sync="error_dialog.show"
          :md-title="error_dialog.title"
          :md-content="error_dialog.content" />
      </group-card>

    </div>

    <div class="md-layout-item md-size-50 no-padding-right">
      <group-card title="Manual Generate Documents" icon="file_upload" :loading="generate_documents">
        <div class="md-layout">
          <div v-for="(document_template, key) in options.document_templates" :key="key">
            <md-checkbox v-model="selected_document_template[key]">{{document_template}}</md-checkbox>
          </div>

        </div>

        <div class="md-layout">
          <!-- Add -->
          <div class="md-layout-item">
            <div>
              <loading-icon-text-button
                @click="generateDocument"
                icon="file_upload"
                :loading="generate_documents"
                :class="{disabled:invalid}"
              >
                Generate
              </loading-icon-text-button>
            </div>
          </div>
        </div>

        <div class="md-layout">
        </div>
      </group-card>
    </div>
  </div>
</ValidationObserver>
</template>

<script>
import { GroupCard } from "@/components";
import { IconCheckbox } from "@/components";
import { ValidatedTextInput } from "@/components";
import ValidatedInputs from '@/components/ValidatedInput';
import GroupCardRow from '@/components/Cards/GroupCardRow';
import { mapGetters } from "vuex";
import { newUploadDocument } from "@/schema.js";
import LoadingIconButton from '@/components/LoadingIconButton';
import LoadingIconTextButton from '@/components/LoadingIconTextButton';
import WaitingDialog from "@/components/Dialogs/WaitingDialog";
import AlertDialog from "../Dialogs/AlertDialog";
import filters from "@/components/utils/filters";

export default {
    components: {
      ...ValidatedInputs,
      GroupCard,
      GroupCardRow,
      IconCheckbox,
      LoadingIconButton,
      LoadingIconTextButton,
    },
    data() {
        return {
          files: [],
          file: null,
          selected_document_type: null,
          uploading_document_id: null,
          loading_document_requests: false,
          generate_documents: false,
          error_dialog: {
            show: false,
            title: '',
            content: '',
          },
          selected_document_template: [],
          selected_applicant: null,
          selected_other_type: '',
        }
    },
    computed: {
        ...mapGetters([
          'options',
          "documentRequests",
          'application',
          'application_status',
        ]),
        documentTypes() {
          if (this.application_status.loaded) {
            if (this.application.applicants.length === 1) {
                const result = this.options.document_types.filter((element) => element != "Applicant 2 Payslip")
                return result;
            }
          }
          return this.options.document_types
        },

      // load the first applicant
      applicant() {
        if (this.application_status.loaded) {
          return this.application.applicants[0];
        }
        return;
      },

      // load all of applicants
      applicants() {
        const applicantsArr = [];
        if (this.application_status.loaded) {
          this.application.applicants.forEach((applicant) => {
            applicantsArr[applicant.id] = filters.name(
              applicant.contact.name,
              false
            );
          });
          if (this.application.applicants.length === 1) {
            this.selected_applicant = applicantsArr[applicantsArr.length - 1];
          }
        }
        return applicantsArr;
      },
    },
    methods: {

      onFileChange(event, index) {
        this.file = event.target.files[0];
      },

      async onUploadFile(){
        await this.uploadFile();
      },

      async uploadFile() {
        let that = this;
        try {
          this.loading_document_requests = true;
          let form_data = new FormData();
          form_data.append("file", this.file);
          form_data.append("document_type_name", this.selected_document_type);
          form_data.append("application_id", this.application.loan.id);
          form_data.append("applicant_name", this.selected_applicant);
          form_data.append('show_all_documents', true);

          if (!this.selected_document_type) {
            this.showAlertDialog("Please select a Document Type", "Document Type is required");
            this.loading_document_requests = false;
            return false;
          }

          if(this.selected_document_type === 'Other' && !this.selected_other_type) {
            this.showAlertDialog("Please provide label for other type", "Other Document label is required");
            this.loading_document_requests = false;
            return false;
          }

          if (!this.selected_applicant) {
            this.showAlertDialog("Please select an Applicant", "Applicant is required");
            this.loading_document_requests = false;
            return false;
          }

          if (!this.file) {
            this.showAlertDialog("Please select file", "File is required");
            this.loading_document_requests = false;
            return false;
          } else {
            const fileTypes = [
              "image/jpeg",
              "image/jpeg",
              "image/gif",
              "image/png",
              "text/plain",
              "text/xml",
              "application/pdf",
              "application/xml",
              "application/msword",
              "application/vnd.oasis.opendocument.text",
              "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
            ];
            if (!fileTypes.includes(this.file.type)) {
              this.showAlertDialog("File Type is not supported", "Only .pdf,.docx,.doc,.jpg,.jpeg,.png,.odt,.txt,.xml files accepted.");
              this.loading_document_requests = false;
              return false;
            }
          }
          if (this.selected_other_type) {
            const fileNameArr = this.file.name.split('.')
            const fileExt = fileNameArr.pop();
            const newFileName =  fileNameArr.join('.')+'-'+this.selected_document_type+'-'+this.selected_other_type+'.'+fileExt;
            form_data.append("file_name", newFileName);
          }

          if (this.file.size === 0) {
            this.showAlertDialog("Please upload a file larger than 0 bytes", "Empty files are not allowed");
            this.loading_document_requests = false;
            return false;
          }

          await axios.post("/api/v1/application/broker_upload_document", form_data, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }).then(function (response) {
            that.$refs.file.value = null;
            that.file = null;
            that.reloadDocuments(response.data);
          }).catch((err) => {
            console.log(err);
            this.showAlertDialog("document upload request failed", err.response.data);
          });
          this.loading_document_requests = false;
        } catch (error) {
          console.error("document upload request failed");
          console.error(error);
          this.loading_document_requests = false;
          this.showAlertDialog("document upload request failed", "document upload request failed");
        }
      },

      dragover(event) {
        event.preventDefault();
        // Add some visual fluff to show the user can drop its files
        if (!event.currentTarget.classList.contains('bg-green-300')) {
          event.currentTarget.classList.remove('bg-gray-100');
          event.currentTarget.classList.add('bg-green-300');
        }
      },
      dragleave(event) {
        // Clean up
        event.currentTarget.classList.add('bg-gray-100');
        event.currentTarget.classList.remove('bg-green-300');
      },
      drop(event) {
        event.preventDefault();
        this.$refs.file.files = event.dataTransfer.files;
        this.file = event.dataTransfer.files[0];
        // Clean up
        event.currentTarget.classList.add('bg-gray-100');
        event.currentTarget.classList.remove('bg-green-300');
      },

      /**
       * reload the uploaded documents and request documents
       *
       * @param param['full_application', 'uploaded_documents']
       * @returns {Promise<void>}
       */
      async reloadDocuments(param) {
        try {
          let response = await this.$store.dispatch('reload_document', param);
        } catch (error) {
          console.error('failed to reload uploaded documents and request documents');
          console.error(error);

          this.error_dialog.title = 'failed to reload uploaded documents and request documents';
          this.error_dialog.content = error.message;
          this.error_dialog.show = true;
        }
      },

      async generateDocument() {
        this.generate_documents = true;
        let payload = {
          document_template_ids: this.selected_document_template,
          application: this.application,
          show_all_documents: true,
        }

        try {
          let response = await this.$store.dispatch('generate_document', payload);

          // popup errors if manually generate documents have errors
          if (response.data.validate_errors.length > 0) {
            this.error_dialog.title = 'failed to generate the document';
            this.error_dialog.content = response.data.validate_errors.map(function (value) {
              return value.message;
            }).toString().replace(/,/g, '<br>'); // use next line to display each error.
            this.error_dialog.show = true;
          }
        } catch (error) {
          console.error(error.response.data);
          this.error_dialog.title = 'failed to generate the document';
          this.error_dialog.content = error.response.data;
          this.error_dialog.show = true;
        }
        this.generate_documents = false;
      },

      showAlertDialog(title, message) {
        this.$modal.show(AlertDialog, { title, message });
      },
    },

    async beforeCreate() {
      const params = {
        types: [
          'document_templates',
          'document_types',
        ],
      }
      await this.$store.dispatch('fetch_types', { params });
    },
}
</script>

<style lang="scss" scoped>
@import '../../assets/scss/theme.scss';
  .dragdrop {
    background: #EEEEEE; /* and other things to make it pretty */
    outline: 2px dashed #cccccc;
    margin: 15px 15px 0 15px;
    text-align: center;
  }
  .dragdrop i {
      color: $ausloans-blue !important;
      font-size: 4em;
  }
  .file-wrapper input {
    cursor: pointer;
    opacity: 0.0;
    filter: alpha(opacity=0);
  }
  .bg-green-300 {
    background: #a5d7ff;
  }
  .bg-gray-100 {
    background: #EEEEEE;
  }
  .cursor-pointer {
    cursor: pointer;
  }
  .dragdrop input[type=file] {
    width: 100%;
    margin-bottom: 10px;
  }
  input[type=file]::file-selector-button{
    background: $ausloans-blue;
    border:none;
    color:white;
    padding:6px 8px;
    cursor: pointer;
    border-radius: 3px;
  }
</style>
